import { Paper } from "@mui/material";
import { toast } from "react-hot-toast";
import { getIcon } from "../../utils/iconConfig";
import { useEffect } from "react";

const CustomToast = ({ message, t, isError, color }) => {
  useEffect(() => {
    setTimeout(() => {
      toast.dismiss(t.id);
    }, 2000);
  }, []);

  return (
    <Paper
      elevation={3}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "fit-content",
        minHeight: "4vw",
        bgcolor: isError
          ? "#FBE3E3"
          : color === "yellow"
          ? "#FCFADA"
          : "#eaf7ec",
        borderRadius: "0.25vw",
        width: "auto",
        mt: "4.5vw",
      }}
    >
      <div
        style={{
          backgroundColor: isError
            ? "#F23D3D"
            : color === "yellow"
            ? "#FFD700"
            : " #50C878",
          width: "3vw",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderBottomLeftRadius: "0.25vw",
          borderTopLeftRadius: "0.25vw",
        }}
      >
        <div
          style={{
            height: "1.2vw",
            width: "1.2vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {getIcon(
            isError ? "circleCross" : color === "yellow" ? "info" : "circleTick"
          )}
        </div>
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "3vw",
          margin: "0vw 0.8vw",
        }}
      >
        <p
          style={{
            fontFamily: "Poppins",
            fontSize: "0.8vw",
            fontWeight: 600,
            lineHeight: "1.1vw",
            letterSpacing: "-0.0205vw",
            color: "#000000",
            textTransform: "capitalize",
          }}
        >
          {message}
        </p>

        <div style={{ cursor: "pointer" }} onClick={() => toast.dismiss(t.id)}>
          {getIcon("Cross")}
        </div>
      </div>
    </Paper>
  );
};

export default CustomToast;
